(function () {
  'use strict';

  // Navbar Toggler
  // ----------------------------------------
  const navbarToggler = document.querySelector(".navbar-toggler");
  const navbarMenu = document.querySelector(".navbar-wrapper");

  if (navbarToggler) {
    navbarToggler.addEventListener("click", () => {
      navbarToggler.classList.toggle("active");
      navbarMenu.classList.toggle("active");
    });
  }

  // Dropdown Menu Toggler For Mobile
  // ----------------------------------------
  const dropdownMenuToggler = document.querySelectorAll(
    ".nav-dropdown > a"
  );

  dropdownMenuToggler.forEach((toggler) => {
    if (toggler) {
      toggler.addEventListener("click", (e) => {
        e.preventDefault();
        $(e.target).closest('li').toggleClass("active");
      });
    }
  });

  // Notice
  // ----------------------------------------
  const notice = $( ".notice" )
  const noticeButton = notice.find( ".notice-close-btn" )

  noticeButton.on('click', () => {
    notice.hide()
    localStorage.setItem('notice-' + notice.data('storage-key'), 'closed')
  })
})();
